// composables/useLookup.js
import { ref, onBeforeUnmount } from 'vue'
import axios from '@/axios'

export const LOOKUP_ENDPOINTS = {
  connections: (q) => `/api/connections?${new URLSearchParams({ query: q })}`,
  country: (q) => `/api/countries?${new URLSearchParams({ query: q })}`,
  city: (q) => `/api/cities?${new URLSearchParams({ query: q })}`,
  region: (q) => `/api/regions?${new URLSearchParams({ query: q })}`,
  branch: (q) => `/api/branch?${new URLSearchParams({ query: q })}`,
  parent_type: (q) => `/api/parent_types?${new URLSearchParams({ query: q })}`,
  sibling_type: (q) => `/api/sibling_types?${new URLSearchParams({ query: q })}`,
  title: (q) => `/api/titles?${new URLSearchParams({ query: q })}`,
  noble_title: (q) => `/api/noble_titles?${new URLSearchParams({ query: q })}`,
  noble_particle_title: (q) => `/api/noble_particle_titles?${new URLSearchParams({ query: q })}`,
  title_suffixes: (q) => `/api/title_suffixes?${new URLSearchParams({ query: q })}`,
  transfer_type: (q) => `/api/transfer_types?${new URLSearchParams({ query: q })}`,
  heirloom_type: (q) => `/api/heirloom_types?${new URLSearchParams({ query: q })}`,
  condition: (q) => `/api/conditions?${new URLSearchParams({ query: q })}`,
  listing_status: (q) => `/api/listing_statuses?${new URLSearchParams({ query: q })}`,
  poi_types: (q) => `/api/poi_types?${new URLSearchParams({ query: q })}`,
  image_types: (q) => `/api/image_types?${new URLSearchParams({ query: q })}`,
  book_years: (q) => `/api/book_years?${new URLSearchParams({ query: q })}`,
  external_owner: (q) => `/api/external_owners?${new URLSearchParams({ query: q })}`,
  external_connections: (q) => `/api/external_connections?${new URLSearchParams({ query: q })}`,
}

export function useLookup(kind, { minChars = 2 } = {}) {
  const buildUrl = LOOKUP_ENDPOINTS[kind]

  if (!buildUrl) {
    throw new Error(`useLookup: unknown lookup kind "${kind}"`)
  }

  const options = ref([])
  const loading = ref(false)
  let time

  const onSearch = (query) => {
    if (!query || query.length < minChars) {
      options.value = []
      return
    }

    clearTimeout(time)
    time = setTimeout(async () => {
      loading.value = true
      try {
        const url = buildUrl(query)
        const { data } = await axios.get(url)
        options.value = Array.isArray(data) ? data : (data.items ?? [])
      } finally {
        loading.value = false
      }
    }, 200)
  }

  onBeforeUnmount(() => {
    clearTimeout(time)
  })

  return { options, loading, onSearch }
}
